import _ from 'lodash';

export const DEFAULT_WHEEL_INFORMATION = {
  productName: '',
  partNumber: '',
  size: '',
  front: {
    rimWidth: '',
    offset: '',
    holeCount: '',
    pcd: '',
    hub: '',
  },
  rear: {
    rimWidth: '',
    offset: '',
    holeCount: '',
    pcd: '',
    hub: '',
  },
};

/** legacy: check_data flat keys (이전 저장분 호환) */
const LEGACY_CHECK_DATA_MAP = {
  WHEEL_PRODUCT_NAME: 'productName',
  WHEEL_PART_NUMBER: 'partNumber',
  WHEEL_SIZE: 'size',
  WHEEL_FRONT_RIM_WIDTH: 'front.rimWidth',
  WHEEL_FRONT_OFFSET: 'front.offset',
  WHEEL_FRONT_HOLE_COUNT: 'front.holeCount',
  WHEEL_FRONT_PCD: 'front.pcd',
  WHEEL_FRONT_HUB: 'front.hub',
  WHEEL_REAR_RIM_WIDTH: 'rear.rimWidth',
  WHEEL_REAR_OFFSET: 'rear.offset',
  WHEEL_REAR_HOLE_COUNT: 'rear.holeCount',
  WHEEL_REAR_PCD: 'rear.pcd',
  WHEEL_REAR_HUB: 'rear.hub',
};

export const LEGACY_WHEEL_CHECK_DATA_KEYS = Object.keys(LEGACY_CHECK_DATA_MAP);

function parseLegacyWheelFromCheckData(checkData = {}) {
  const parsed = _.merge({}, DEFAULT_WHEEL_INFORMATION);
  LEGACY_WHEEL_CHECK_DATA_KEYS.forEach((key) => {
    const path = LEGACY_CHECK_DATA_MAP[key];
    const value = _.get(checkData, key);
    if (value !== undefined && value !== null && String(value).trim() !== '') {
      _.set(parsed, path, String(value));
    }
  });
  return parsed;
}

/** vehicle_information.wheelInformation 우선, 없으면 check_data(구버전) */
export function parseWheelInformation(vehicleInformation = {}, checkData = null) {
  const fromVehicle = _.get(vehicleInformation, 'wheelInformation');
  if (fromVehicle && Object.values(fromVehicle).some((v) => v !== '' && v != null)) {
    return _.merge({}, DEFAULT_WHEEL_INFORMATION, fromVehicle);
  }
  if (
    fromVehicle &&
    (fromVehicle.productName ||
      fromVehicle.partNumber ||
      fromVehicle.size ||
      _.get(fromVehicle, 'front.rimWidth'))
  ) {
    return _.merge({}, DEFAULT_WHEEL_INFORMATION, fromVehicle);
  }
  if (fromVehicle) {
    return _.merge({}, DEFAULT_WHEEL_INFORMATION, fromVehicle);
  }
  if (checkData) {
    const legacy = parseLegacyWheelFromCheckData(checkData);
    if (
      legacy.productName ||
      legacy.partNumber ||
      legacy.size ||
      legacy.front.rimWidth
    ) {
      return legacy;
    }
  }
  return _.merge({}, DEFAULT_WHEEL_INFORMATION);
}

export function mergeWheelIntoVehicleInformation(vehicleInformation = {}, wheelInformation) {
  return {
    ...vehicleInformation,
    wheelInformation: _.merge(
      {},
      DEFAULT_WHEEL_INFORMATION,
      wheelInformation || _.get(vehicleInformation, 'wheelInformation')
    ),
  };
}

export function formatWheelSpecRow(prefix, wheel) {
  const row = _.get(wheel, prefix, {});
  return [
    row.rimWidth || '-',
    row.offset || '-',
    row.holeCount || '-',
    row.pcd || '-',
    row.hub || '-',
  ];
}

export function hasWheelInformation(wheel) {
  const w = _.merge({}, DEFAULT_WHEEL_INFORMATION, wheel);
  return !!(
    w.productName ||
    w.partNumber ||
    w.size ||
    w.front.rimWidth ||
    w.front.offset ||
    w.rear.rimWidth
  );
}
